// globalne obiekt - taka przekazywarka
define(['jquery'], function ($) {

  var global = {},
    $main,
    $site,
    $sidebar,
    $headerSearch;

  // cache dla używanych jQuery object, sprawdzamy już bez length, bo jak jest to jest na pewno,
  // a jak nie ma to undefined, length dla undefined spowoduje błąd
  global.cache = {
    $html: $('html'),
    $body: $('body')
  };

  global.desktopSiteOnTablet = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  //global.desktopSiteOnTablet = true;

  global.text = {
    close: 'Zwiń',
    open: 'Rozwiń'
  };

  // do gs np.
  global.ie = /msie|trident/ig.test(window.navigator.userAgent);

  global.ajax = {};

  global.ie8 = global.cache.$html.is('.ie8');
  global.ie9 = global.cache.$html.is('.ie9');
  // global.ltie10 = global.cache.$html.is('.lt-ie10');

  // przydatne dla skryptów grayscale
  // true|undefined
  global.gs = global.cache.$body.data('gs');

  // przydatne dla js
  global.staticDir = global.cache.$body.data('static');
  if (!global.staticDir) {
    global.staticDir = '/static/_front/_inteligo/';
  }

  $main = $('#main');
  if ($main.length) {
    global.cache.$main = $main;
  }
  $sidebar = $('#sidebar');
  if ($sidebar.length) {
    global.cache.$sidebar = $sidebar;
  }

  $headerSearch = $('#header-search');
  if ($headerSearch.length) {
    global.cache.$headerSearch = $headerSearch;
  }

  $site = $('#site');
  if ($site.length) {
    global.cache.$site = $site;
  }

  return global;

});



// WEBPACK FOOTER //
// ./_front/_inteligo/js/app/global.js